import { useStore } from '@/hooks/useStore';
import { cn } from '@/utils/utils';
import { observer } from 'mobx-react-lite';
import { ReactNode, useMemo, useRef, useState, useLayoutEffect } from 'react';
import Footer from './footer/Footer';
import Header, { HeaderProps } from './Header';
import { useLocation } from 'react-router-dom';
import { ROUTES } from '@/configs/constants';

interface ContainerBodyProps extends HeaderProps {
    children: ReactNode,
    showHeader: boolean,
    showFooter: boolean,
    bodyClassname?: string,
    isErrorPage?: boolean
}

const headerHeightDefault = 5; // rem
const footerHeightDefault = 9.8125; // rem

export default observer(function ContainerBody({
    children,
    showHeader,
    showFooter,
    headerMobileComponent,
    headerMobileComponentForGeneral,
    bodyClassname,
    isErrorPage = false
}: ContainerBodyProps) {
    // hook
    const { pathname } = useLocation();
    const isComingSoonPage = pathname.includes(ROUTES.comingSoon.href);

    // store
    const {
        uiStore: { windowSize, devicesScreen }
    } = useStore();

    const { desktop } = devicesScreen;

    const footerRef = useRef<HTMLElement | null>(null);
    // state for dynamic minHeightContent
    const [footerHeight, setFooterHeight] = useState<number>(footerHeightDefault);

    useLayoutEffect(() => {
        if (showFooter && footerRef.current) {
            const updateFooterHeight = () => {
                setFooterHeight(footerRef.current ? footerRef.current.offsetHeight / 16 : footerHeightDefault);
            };
            updateFooterHeight();

            // Optional: Listen for resize events
            const resizeObserver = new window.ResizeObserver(updateFooterHeight);
            resizeObserver.observe(footerRef.current);

            return () => {
                resizeObserver.disconnect();
            };
        }
    }, [showFooter, windowSize]);

    const minHeightContent = useMemo(() => {
        let heightHeader = 0, heightFooter = 0;

        if (showHeader) {
            heightHeader = headerHeightDefault;
        }

        if (showFooter) {
            heightFooter = footerHeight;
        }

        return (isErrorPage || isComingSoonPage) ?
            heightHeader :
            heightHeader + heightFooter;
    }, [showHeader, showFooter, footerHeight, devicesScreen, windowSize, isErrorPage]);

    return (
        <>
            {/* Header */}
            {showHeader && (
                <Header
                    headerMobileComponent={headerMobileComponent}
                    headerMobileComponentForGeneral={headerMobileComponentForGeneral}
                />
            )}

            {/* Body */}
            <section className={cn(
                desktop,
                bodyClassname
            )}
            >
                <div
                    style={{ minHeight: `calc(100vh - ${minHeightContent}rem)` }}
                    className={cn(
                        showHeader && 'point-940:mt-[80px] mt-[min(60px,15vw)]',
                        (isComingSoonPage || isErrorPage) && 'flex flex-1 items-center'
                    )}
                >
                    {children}
                </div>
            </section>

            {/* Footer */}
            {/* {
                showFooter && (
                    <footer ref={footerRef}>
                        {showFooter && (
                            <Footer />
                        )}
                    </footer>
                )
            } */}
            <footer ref={footerRef}>
                {showFooter && (
                    <Footer />
                )}
            </footer>
        </>
    );
});
